// Enterprise Example Model
export class EnterpriseExample {
  constructor(data = {}) {
    this.id = data.id || null;
    this.enterpriseId = data.enterpriseId || null;
    this.reportType = data.reportType || '';
    this.transcription = data.transcription || '';
    this.correctedContent = data.correctedContent || '';
    this.orderIndex = data.orderIndex || 0;
    this.isActive = data.isActive !== undefined ? data.isActive : true;
    this.createdAt = data.createdAt ? new Date(data.createdAt) : null;
    this.updatedAt = data.updatedAt ? new Date(data.updatedAt) : null;
  }
}
